/**
 * Smart Compose (old-cockpit parity) — inline ghost completion for the agent
 * composer. The dashboard debounces the draft through the staff-authenticated
 * suggest endpoint; `searchText` is echoed back so stale (out-of-order)
 * responses can be discarded, exactly like the old cockpit's search_word guard.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';

export interface ComposeSuggestion {
  /** Echo of the queried text — discard the response if the draft moved on. */
  searchText: string;
  /** The ghost completion to render after the caret, or null when no match. */
  suggestion: string | null;
}

export class ComposeResource {
  constructor(private readonly http: HttpClient) {}

  suggest(text: string): Promise<ComposeSuggestion> {
    return this.http.post(endpoints.compose.suggest(), { text });
  }
}
